"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_component_1 = require("../map.component");
const _4d_mapper_1 = require("4d-mapper");
const operators_1 = require("rxjs/operators");
const map_service_1 = require("../../../commons/map.service");
const app_service_1 = require("../../../commons/app.service");
const BaseComponent_1 = require("../../../commons/BaseComponent");
const Constants_1 = require("../../../commons/Constants");
const acl_service_1 = require("../../../commons/acl/acl.service");
const map_data_service_1 = require("../../../v2/commons/map-data.service");
const file_data_service_1 = require("../../../v2/commons/file-data.service");
const ui_manager_service_1 = require("@src/app/xs/services/ui/ui-manager.service");
const _ = require("lodash");
const incoming_data_service_1 = require("@src/app/xs/services/data/incoming-data.service");
// const Cesium = (<any>window).Cesium;
// declare var fdm: any;
class ProcessingComponent extends BaseComponent_1.BaseComponent {
    constructor(route, router, fourD, incomingData, snackBar, dialog, mapService, uiManager, permissions, service, dataService, file) {
        super(router, snackBar, dialog);
        this.route = route;
        this.router = router;
        this.fourD = fourD;
        this.incomingData = incomingData;
        this.mapService = mapService;
        this.uiManager = uiManager;
        this.permissions = permissions;
        this.service = service;
        this.dataService = dataService;
        this.file = file;
        this.debug = Constants_1.Constants.debug_off;
        // permissions
        this.allowed = {};
        // is this loading?
        this.loading = false;
        this.states = [
            { label: 'Open', id: 'open', uid: null, items: [] },
            { label: 'In queue', id: 'in_queue', uid: null, items: [] },
            { label: 'In processing', id: 'in_processing', uid: null, items: [] },
            { label: 'Success', id: 'finished_success', uid: null, items: [] },
            { label: 'Fail', id: 'finished_failed', uid: null, items: [] },
            { label: 'Aborted', id: 'finished_aborted', uid: null, items: [] }
        ];
        // registered processing plugins
        this.plugins = [];
        this.categories = null;
        this.currentlySelected = null;
        this.runningJobs = {};
        this.activeJobs = [];
        this.editWorkflowSelected = null;
        this.workflowJobType = null;
        this.previewState = 'open';
        this.previewStep = 0;
        this.previewPluginController = null;
        this.pluginCache = false;
        this.languageJSON = {};
        // never initialize in the constructor
        // this.cesiumHelper = mapService.helper;
    }
    init() {
        this.fourD.onActiveAccountReady().subscribe(s => {
            /* disabled, possibly remove
            // access control changes
            this.permissions.updatedAccess$.subscribe(tmp => {
              if ( this.debug ) { console.log ( 'main subscribed event access control' );}
              this.permissionsChanged();
            });
            */
            this.dataService.sceneJobs.state.pipe(operators_1.filter(a => !!a), operators_1.take(1)).subscribe(jobs => {
                this.fourD.jobTypes.filter(j => j.pluginType && j.pluginType != '').forEach(j => {
                    let item = {
                        id: '' + j.id,
                        uid: '' + j['uid'],
                        name: j.name,
                        icon: j.icon,
                        category: j.category,
                        mode: 'job',
                        jobTypeRef: j,
                        items: jobs.filter(jj => jj.jobType == j)
                    };
                    this.plugins.push(item);
                    // console.log ( ' @@ job', item );
                });
            });
            this._subs.push(this.file.processingItems.state.subscribe(proc => {
                this.runningJobs = {};
                proc.forEach(element => {
                    if (element.task instanceof _4d_mapper_1.Job)
                        this.runningJobs['' + element.task.id] = true;
                });
            }));
            // inject incoming job types into the plguins
            this._subs.push(this.dataService.sceneJobs.events.subscribe(j => {
                if (j.event == 'ADD') {
                    // console.log ( ' @@ job ADD', j );
                    this.activeJobs.push(j.item);
                    var node = this.plugins.find(p => p.mode == 'job' && p.id == '' + j.item.jobType.id);
                    if (node)
                        node.items.push(j.item);
                }
                else if (j.event == 'REMOVE') {
                    // console.log ( ' @@ job REMOVE', j );
                    var node = this.plugins.find(p => p.mode == 'job' && p.id == '' + j.item.jobType.id);
                    if (node)
                        node.items = node.items.filter(i => i != j.item);
                }
                else if (j.event == 'UPDATE' && j.item.status == 'finished') {
                    // console.log ( ' @@ job UPDATE', j );
                    var node = this.plugins.find(p => p.mode == 'job' && p.id == '' + j.item.jobType.id);
                    node.items = node.items.filter(i => i != j.item);
                }
            }));
            this.fourD.transformTypes.filter(j => j.pluginType && j.pluginType != '').forEach(j => {
                // console.log ( ' @@ transform ADD', j );
                if (this.permissions.can)
                    this.plugins.push({ id: '' + j.id, name: j.name, icon: j.icon, category: j.category, mode: 'transform' });
            });
            // crete our categories, with sub-jobs/transforms underneath
            this.categories = new Map();
            this.plugins.map(p => {
                if (!this.categories.has(p.category)) {
                    this.categories.set(p.category, {});
                }
                let category = this.categories.get(p.category);
                category[p.id] = p;
                this.categories.set(p.category, category);
            });
        });
        this.previewPluginController = {
            id: 999,
            meta: {
                category: 'preview'
            },
            hideDelete: true,
            hideHeader: true,
            item: null,
            controller: null,
            controls: [],
            getLabel: function () { return 'preview'; },
            refresh: function () { },
            save: function () { },
            has: function () { return false; },
            linearScale: function () { },
            goto: function (p) {
                // console.log('goto() !!!!!!!!!!!', p);
            },
            show: function (p) {
                // console.log('show() !!!!!!!!!!!', p);
            },
            hide: function (p) {
                // console.log('hide() !!!!!!!!!!!', p);
            },
        };
    }
    slugify(text) {
        return text
            .toString()
            .normalize('NFD') // split an accented letter in the base letter and the acent
            .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
            .toUpperCase()
            .trim()
            .replace(/\s+/g, '_')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '_');
    }
    ;
    populatePluginController(items) {
        if (!this.pluginCache) {
            let these = [];
            items.forEach(i => {
                let a = _.cloneDeep(i);
                let t = '';
                if (i && i.label_token) {
                    t = i.label_token;
                }
                a.name = this.slugify(t);
                these.push(a);
            });
            this.previewPluginController.controls = these;
            this.createLanguageJSON();
            this.pluginCache = true;
        }
        return true;
    }
    createLanguageJSON() {
        let res = {};
        if (this.editWorkflowSelected) {
            let uid = ('' + this.editWorkflowSelected.uid).toUpperCase();
            res[uid] = {};
            if (this.editWorkflowSelected['worflow-template']) {
                this.editWorkflowSelected['worflow-template'].forEach(step => {
                    let stepIdx = 'STEP_' + (step.step + 1);
                    res[uid][stepIdx] = {};
                    step.states.forEach(state => {
                        state.items.forEach(item => {
                            let content = '';
                            if (item.value) {
                                content = item.value;
                            }
                            if (item.label_token) {
                                res[uid][stepIdx][this.slugify(item.label_token)] = '';
                            }
                            if (item.text_token) {
                                res[uid][stepIdx][this.slugify(item.text_token)] = content;
                            }
                        });
                    });
                });
            }
        }
        this.languageJSON = res;
        /*
        <ng-container *ngFor="let step of editWorkflowSelected['worflow-template']">
    
                      <div><b>{{ step.label_token }}</b></div>
    
                      <ng-container *ngFor="let state of step.states">
                          <ng-container *ngFor="let item of state.items">
                            <div *ngIf="item.label_token">{{ step.label_token + '.' + item.label_token.toUpperCase() }}</div>
                            <div *ngIf="item.text_token">{{ step.label_token + '.' + item.text_token.toUpperCase() }}</div>
                          </ng-container>
                      </ng-container>
    
                    </ng-container>
                    */
    }
    editWorkflow(job = null) {
        this.workflowJobType = job.jobTypeRef;
        this.editWorkflowSelected = this.workflowJobType.baseTransform;
        // console.log('@@@ editWorkflow()', this.workflowJobType, this.editWorkflowSelected );
    }
    saveWorkflow(steps = null) {
        if (this.editWorkflowSelected) {
            this.editWorkflowSelected['worflow-template'] = _.cloneDeep(steps);
            console.log('@@@ saveWorkflow()', steps);
            this.editWorkflowSelected.saveObservable().subscribe(done => {
                console.log('@@@ saveWorkflow() SAVED', this.editWorkflowSelected, done);
            });
        }
    }
    clickedMap(movement, rightClick, checkedPosition) {
        return map_component_1.ClickDisplay.None;
    }
    becameActive(mapComp) {
        // if ( this.debug ) { console.log ( 'processing.comp :: becameActive()' ); }
        if (this.mapService.scene) {
            this.incomingData.populateFromScene(this.mapService.scene);
        }
        this.mapComp = mapComp;
        /*
        if (this.mapService.scene) { // get list of datasets which user can tile from layers.
          if (this.mapService.scene.folder) {
            this.mapComp.fetchDatasetForManualTiling(this.mapService.scene.folder);
          } else {
            this.mapService.scene.fetchObservable().subscribe(_ => {
              // TODO : there's a bug here where scene can be null, but I don't know exactly what this code is trying to do (@haresh)
              if (this.mapService.scene.folder) {
                this.mapComp.fetchDatasetForManualTiling(this.mapService.scene.folder);
              }
            });
          }
        }
        */
    }
    becameInactive(mapComp) {
    }
}
exports.ProcessingComponent = ProcessingComponent;
